var cov_xhoo7yztf = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Form/styles/index.js",
      hash = "df302f4e4fa419bef28d9fa1037b6d3b8ae3775a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Form/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      },
      "1": {
        start: {
          line: 6,
          column: 32
        },
        end: {
          line: 6,
          column: 67
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var formLess = {};
import genaration from '../../utils/classname';
export var formClass = (cov_xhoo7yztf.s[0]++, genaration(formLess, 'form'));
export var inputBorderClass = (cov_xhoo7yztf.s[1]++, genaration(formLess, 'inputBorder'));